<template>
	<div class="main">
		<div class="Switch_roles" id="roleChooseWindow">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<p class="lost">{{ $t('switch_character_text') }}</p>
			<div class="Server">
				<i class="fa fa-list-ul color"></i>
				<select class="select_back" v-model="serverCode" v-on:change="loadRoleList()">
					<option v-for="server in serverList" :value="server.serverCode">{{ server.serverName }}</option>
				</select>
			</div>
			<div class="Server_role">
				<i class="fa fa-user color"></i>
				<select class="select_back" v-model="roleId">
					<option v-for="role in roleList" :value="role.roleId">{{ role.roleName }}</option>
				</select>
			</div>
			<button class="Switch_confirmation bg_color" v-on:click="chooseRoleInfo()">{{ $t('confirm_text') }}</button>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import {
	isEmpty
} from '../utils/index.js'
export default {
	name: 'roleInfo',
	components: {},
	data() {
		return {
			serverCode: null,
			roleId: null,
			serverList: [],
			roleList: []
		}
	},
	async mounted() {
		if (this.$session.hasLogin()) {
			await this.loadGameServerList();
			const hasCache = !!localStorage.getItem('new__role_info');
			if (hasCache) {
				await this.setDefaultRoleFromLocalStorage();
			} else if (!isEmpty(this.serverList)) {
				this.serverCode = this.serverList[0].serverCode;
				await this.loadRoleList();
			}
		}
	},
	methods: {
		async loadGameServerList() {
			let response = await this.$axios({
				method: 'get',
				url: '/web/api/game/loadServerList',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode()
				}
			})

			if (response.code === 1000) {
				this.serverList = response.data;
			} else {
				this.serverList = [];
				this.roleList = [];
			}

		},
		async loadRoleList() {
			this.roleList = [];
			let response = await this.$axios({
				method: 'get',
				url: '/web/api/game/loadRoleList',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
					serverCode: this.serverCode
				}
			})
			if (response.code === 1000) {
				this.roleList = response.data;
				if (!isEmpty(this.roleList)) {
					// 如果当前 roleId 已在列表中，則保留它；否則默認選中第一個
					const exists = this.roleList.some(role => role.roleId === this.roleId);
					if (!exists) {
						this.roleId = this.roleList[0].roleId;
					}
				}
			} else {
				this.roleList = [];
			}

		},
		assembleRoleInfo: function () {
			let _server = this.serverList.find(el => el.serverCode == this.serverCode);
			let _role = this.roleList.find(el => el.roleId == this.roleId);
			if (!_server || !_role) return null;

			let roleInfo = {
				serverCode: _server.serverCode,
				serverName: _server.serverName,
				roleId: _role.roleId,
				roleName: _role.roleName,
				roleLevel: _role.roleLevel,
				roleAvatar: _role.roleAvatar,
				object: _role
			}
			return roleInfo;
		},
		chooseRoleInfo: function () {
			const roleInfo = this.assembleRoleInfo();
			if (!roleInfo) return;
			this.$cache.setRoleInfo(roleInfo);
			this.$analytics.track('role_selected', { role_server_code: roleInfo.serverCode });
			this.$analytics.flush();
			$("#roleChooseWindow").bPopup().close();
			window.location.reload();
		},
		// 充值玩家信息默认选中角色
		async setDefaultRoleFromLocalStorage() {
			try {
				const storedRoleInfo = JSON.parse(localStorage.getItem('new__role_info'));
				if (storedRoleInfo) {
					this.serverCode = storedRoleInfo.serverCode;
					this.roleId = storedRoleInfo.roleId;

					// 等待角色列表加載並驗證 roleId 是否有效
					await this.loadRoleList();
				}
			} catch (error) {
				console.error('解析 localStorage 中的角色信息失敗:', error);
			}
		}
	}
}
</script>

<style></style>
